import { render, staticRenderFns } from "./instSmartId.vue?vue&type=template&id=388196f4&scoped=true"
import script from "./instSmartId.vue?vue&type=script&lang=js"
export * from "./instSmartId.vue?vue&type=script&lang=js"
import style0 from "./instSmartId.vue?vue&type=style&index=0&id=388196f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "388196f4",
  null
  
)

export default component.exports